import React from 'react';
import { useZoomLevel } from '@atlassian/jira-portfolio-3-horizontal-scrolling/src/controllers/index.tsx';
import FixedAxis from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/axis';
import InfiniteAxis from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/infinite-axis';

export const TimelineAxis = () => {
	const [zoomLevel] = useZoomLevel();
	return zoomLevel === undefined ? <FixedAxis /> : <InfiniteAxis />;
};
